'use strict';

let variation;

function gtm_getCookie(name) {
  try {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
    return null;
  } catch (e) {
    console.error('Error in gtm_getCookie:', e.message);
    return "v0"; // fallback value
  }
}

function gtm_setCookie(name, value, days) {
  try {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/;domain=.{{*Base URL}}";
  } catch (e) {
    console.error('Error in gtm_setCookie:', e.message);
    // Here, you might want to do something else if setting the cookie fails.
    // Returning "v0" may not make sense in this context, but you could still handle the error in some manner.
  }
}

const initExperiment = (exp_id, iteration = "v0.01", force_activate_variation) => {
  let exp_handle = exp_id.replace("-", "").toLowerCase();

  if(force_activate_variation){
    variation = force_activate_variation;
  } else {
    if(getParam("qa").indexOf(exp_handle) > -1){
      variation = getParam("qa").replace(exp_handle, "");
    } else {
      variation = window.sessionStorage.getItem(exp_id);
    }
  }

  let exp_tag = exp_handle + variation;
  document.documentElement.classList.add(exp_tag);
  console.log(`init ${exp_id}${variation} -- ${iteration}`);

  return variation;
};

function waitForElement(selector) {
  return new Promise(function(resolve, reject) {
    var element = document.querySelector(selector);

    if(element) {
      resolve(element);
      return;
    }

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        var nodes = Array.from(mutation.addedNodes);
        for(var node of nodes) {
          if(node.matches && node.matches(selector)) {
            observer.disconnect();
            resolve(node);
            return;
          }
        };
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
}

// shim layer with setTimeout fallback
const requestAnimFrame = (function () {
  return window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 3000 / 60);
    };
})();

function waitUntil(test) {
  return new Promise(function(resolve){
    (function poll() {
      if (!test()) return requestAnimFrame(poll, 50);
      return resolve();
    })();
  });
};

const observeSelector = (selector, callback, options = {
  timeout: null,
  once: false,
  onTimeout: null,
  document: window.document
}) => {
  let processed = new Map();

  if (options.timeout || options.onTimeout) {
    console.log('------------------------------------------------------------------------------------------------------------------------------');
    console.log('WARNING: observeSelector options timeout and onTimeout are not yet implemented.');
    console.log('------------------------------------------------------------------------------------------------------------------------------');
  }

  let obs, isDone = false;
  const done = () => {
    if (!obs) console.warn('observeSelector failed to run done()');
    if (obs) obs.disconnect();
    processed = undefined;
    obs = undefined;
    return isDone = true;
  };

  const processElement = el => {
    if (processed && !processed.has(el)) {
      processed.set(el, true);
      callback(el);
      if (options.once) {
        done();
        return true;
      }
    }
  };

  const lookForSelector = (el = document) => {
    if (el.matches && el.matches(selector)) {
      if (processElement(el)) return true;
    }
    if (el.querySelectorAll) {
      const elements = el.querySelectorAll(selector);
      if (elements.length) {
        for (let i = 0; i < elements.length; i++) {
          const el = elements[i];
          if (processElement(el)) return true;
        }
      }
    }
  };
  lookForSelector();

  //We might finish before the mutation observer is necessary:
  if (!isDone) {
    obs = new MutationObserver(mutationsList => {
      mutationsList.forEach(record => {
        if (record && record.addedNodes && record.addedNodes.length) {
          for (let i = 0; i < record.addedNodes.length; i++) {
            //Need to check from the parent element since sibling selectors can be thrown off if elements show up in non-sequential order
            const el = record.addedNodes[i].parentElement;
            // if (!el) console.warn('observeSelector element has no parent', record.addedNodes[i], record);
            //Note: This appears to also run when elements are removed from the DOM. If the element doesn't have a parent then we don't need to check it.
            if (el && lookForSelector(el)) return true;
          }
        }
      });
    });
    obs.observe(options.document || document, {
      attributes: false,
      childList: true,
      subtree: true
    });
  }

  return () => {
    done();
  };
}; //_observeSelector

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

const setCookie = (name, value, expdays) => {
  const d = new Date();
  d.setTime(d.getTime() + (expdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
};

const delCookie = (name, path, domain) => {
  if( getCookie( name ) ) {
    document.cookie = name + "=" +
      ((path) ? ";path="+path:"")+
      ((domain)?";domain="+domain:"") +
      ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
  }
};

//-----------

const getParam = (name, optSearch) => {
  'use strict';
  optSearch = optSearch || location.search;
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
    results = regex.exec(optSearch);
  return results === null ?
    '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function gtm_add_cartAttribute(attr_name, attr_val, multiple_attr_array = []) {
  let body_attributes = `attributes[${attr_name}]=${attr_val}`;
  if(multiple_attr_array.length > 0){
    body_attributes = multiple_attr_array.join('&'); 
  }
  
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    body: body_attributes
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok.');
    }
    return response.json();
  })
  .then(data => {
    console.log('Cart updated successfully:', data);
    window.cart_attributes_updated = true;
  })
  .catch(error => {
    console.error('Failed to update cart:', error);
  });
}

// add experiment data to cart
setTimeout(() => {
  // 7.5s timeout is to allow tags to initialize, sub 8s pageviews are rarely valid anyhow
  let exp_cart_data = [];
  if (window.dataLayer && Array.isArray(window.dataLayer)) {
    
    // Loop through the dataLayer 
    for (var i = 0; i < window.dataLayer.length; i++) {
      var dl_item = window.dataLayer[i];
      if (dl_item && typeof dl_item === 'object' && dl_item.event == "proteus_experiment_pageview") {
        var exp_id = dl_item.proteus_exp_id;
        var exp_var = dl_item.proteus_var_id;
        exp_cart_data.push("attributes[proteus-experimentation-" + exp_id.toLowerCase() + "]=[" + exp_id + "]" + exp_var);
        if(i == window.dataLayer.length - 1 && exp_cart_data.length > 0){
          // last loop
          console.log("add cart attributes exp_cart_data", exp_cart_data);
          gtm_add_cartAttribute(false, false, exp_cart_data);
        }     
      }
    }
    
  }

}, 7500)

//-----------

const js_loadScript = (url, optCallback) => {
  'use strict';
  const ga = document.createElement('script');
  ga.type = 'text/javascript';
  ga.async = true;
  ga.src = url;
  if (typeof optCallback === 'function') {
    ga.onload = optCallback;
  }
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(ga, s);
};

//----

async function add_items_to_cart(items) {
  console.log('add_items_to_cart()', items);
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(items),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      console.log('Item added to cart', data);
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      /*
      // update cart count + open drawer as needed
      (async function () {
        let cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        console.log(cartContent);
        document.querySelector('.header__cart-count cart-count').innerText = cartContent.item_count;
        document.querySelector('.header__cart-count cart-count').removeAttribute('style');
        document.querySelector('.header__cart-count cart-count').removeAttribute('aria-hidden');

        // open cart if closed
        if (document.querySelector('cart-drawer').classList.value.indexOf('show-close-cursor') == -1) {
          document.querySelector('cart-drawer').setAttribute('open', '');
        }
      })();
      */
      
    })
    ['catch'](function (error) {
      console.error('Error adding item to cart:', error);
    });
}

const cart_remove_items = (var_ids, callback) => {
  //check cart, and if any specified items exist, remove them
  console.log(`cart_remove_items(${var_ids})`);
  get_cart_json().then(data => {
    for(let i = 0; i < data.items.length; i++){
      for(let ii = 0; ii < var_ids.length; ii++){
        console.log(`searching for ${var_ids[ii]} === ${data.items[i].variant_id}`);
        if(data.items[i].variant_id === var_ids[ii]){
          console.log(`... removing ${var_ids[ii]}`);
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {quantity: 0, id: var_ids[ii]},
            dataType: 'json',
            success: callback
          });
        }

      } //endfor ii
    } //endfor i
  });
};

const cart_add_item = (var_id, qty, callback) => {
  console.log(`cart_add_item(${var_id}, ${qty})`);

  let atc_data = {quantity: qty, id: var_id};
  if(window.sessionStorage.getItem("WBLS-Progressive-Cart-Mystery")){
    atc_data = {quantity: qty, id: var_id, properties: {Gift: "Mystery"} };
  } else if(window.sessionStorage.getItem("WBLS-37")){
    atc_data = {quantity: qty, id: var_id, properties: {QA: "WBLS-37"} };
  } else if(window.sessionStorage.getItem("WBLS-31")){
    atc_data = {quantity: qty, id: var_id, properties: {Email: "Free Gift"} };
  }
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: atc_data,
    dataType: 'json',
    success: callback
  });
  
};

const get_cart_json = () => {
  // console.log(`get_cart_json()`);
  return $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(data) {
      // return data;
    }
  });
};

const cart_contains_subscription = () => {
  return get_cart_json().then(data => {
    for(let i = 0; i <= data.items.length; i++){
      if(i === data.items.length){
        // console.log('no subs found', i);
        return false;
      } else {

        if(data.items[i].properties && data.items[i].properties.shipping_interval_frequency){
          // console.log("subs found in item", i);
          return true;
        } else {
          // console.log('has properties, not sub tho', i);
        }

      }
    }
  });
};

const cart_contains_item = (var_id) => {
  // console.log(`cart_contains_item(${var_id})`);
  return get_cart_json().then(data => {
    for(let i = 0; i <= data.items.length; i++){
      if(i === data.items.length){
        // console.log('item not found', i);
        return false;
      } else {
        if(data.items[i].variant_id === var_id){
          // console.log("item found", i);
          return true;
        }
      }
    }
  });
};

/*
cart_contains_item(39321012895847).then(response => {
  console.log("cart_contains_item(39321012895847)",response);
});
*/


// loadScript("https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js", () => {
//   console.log("jQuery re-loaded");
// }); //loadScript()

//----

waitUntil(() => {
  return typeof gtag != "undefined";
}).then(() => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
      'event': 'ga_configured'
  });
}).catch();

// disable ATC buttons until cart is ready
waitForElement('body').then(doc => {
  doc.setAttribute("data-atc-active", false)

  fetch('/cart.js').then(response => {
    return response.json();
  }).then(cart => {
    // cart is ready
    setTimeout(() => {
      doc.setAttribute("data-atc-active", true)
    }, 1250)
  }).catch()

  // in case it doesn't resolve naturally
  setTimeout(() => {
    doc.setAttribute("data-atc-active", true)
  }, 5000)
})